import React, { useState } from "react";
import axios from "axios";
import MenuPage from "../menu-page/menu-page";
import { useUser } from "../auth/is_loggedin";
import header from "../../../images/supportheader.gif";
import footer from "../../../images/supportfooter.gif";

import { useTranslation } from "react-i18next";
import LinkButton from "../link-button/link-button";
import Perk from "./perk";
import Button from "@/components/ui/button";
import { useToken } from "../../../authToken";
import RoomAPI from "../../../RoomAPI";

const Supporter: React.FunctionComponent = () => {
  const user = useUser();
  const token = useToken();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { t } = useTranslation("main");

  const handleCheckout = async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const successUrl = `${window.location.origin}/thankyou`;
      const cancelUrl = `${window.location.origin}/supporter`;
      const { url } = await RoomAPI.CreateCheckout(token, successUrl, cancelUrl);
      if (!url) throw new Error("No checkout URL returned");
      window.location.href = url;
    } catch (e) {
      console.error("Checkout error:", e);
      if (axios.isAxiosError(e) && e.response?.status === 401) {
        setError("Your session has expired. Please log out and log in again.");
      } else if (axios.isAxiosError(e) && !e.response) {
        setError("Could not reach the server. Please check your connection and try again.");
      } else {
        setError("Something went wrong starting checkout. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <MenuPage
      titles={[t("supporter.headers.default")]}
      subHeaders={[t("supporter.subheaders.default")]}
    >
      {user === undefined && (
        <div className={"w-full p-2"}>
          <LinkButton path={"/user"} size={"2xl"} className={"w-full"}>
            users have to be logged in to become supporters. click here to log
            in.
          </LinkButton>
        </div>
      )}

      <div>
        <img src={header} alt={"support us styled-header"} />
      </div>

      <div
        className={
          "flex flex-col flex-1 self-stretch m-4 space-y-8 justify-center"
        }
      >
        <div className={"flex flex-row justify-center space-x-8"}>
          <div
            className={"w-2/5 flex flex-col items-end space-y-2 text-3xl"}
          >
            <Button
              size={"2xl"}
              disabled={user?.premium || loading || !token}
              className={"p-2 self-stretch"}
              onClick={handleCheckout}
            >
              {t("supporter.body.purchase")}
            </Button>
            <Button
              size={"2xl"}
              disabled={user?.premium || loading || !token}
              className={"p-2"}
              onClick={handleCheckout}
            >
              $4.99
            </Button>
          </div>

          <div
            className={
              "w-3/5 flex flex-col text-base leading-none space-y-4 bg-night-primary pb-4 shadow-basic"
            }
          >
            <div
              className={
                "text-3xl text-white bg-black p-3 flex justify-center items-center"
              }
            >
              {t("supporter.body.perksTitle")}
            </div>

            <Perk label={t("supporter.body.perk1")} />
            <Perk label={t("supporter.body.perk2")} />
            <Perk label={t("supporter.body.perk3")} />
            <Perk label={t("supporter.body.perk4")} />
            <Perk label={t("supporter.body.perk5")} />
          </div>
        </div>

        {error && (
          <div className={"text-red-500 text-center text-lg"}>{error}</div>
        )}

        {/*<div className={"fake-button text-left"}>*/}
        {/*    <p className={"font-bold"}>If you supported Frantic Fanfic in 2021:</p>*/}
        {/*    <br/>*/}

        {/*    <ol>*/}
        {/*        <li>Login to franticfanfic.com with your Discord or Twitter.</li>*/}
        {/*        <li>Email franticfanficgame@gmail.com with the email address that you sent a Ko-fi with/bought merch*/}
        {/*            with and*/}
        {/*            include:*/}
        {/*            <ul className={"pl-6"}>*/}
        {/*                <li>The Discord / Twitter name you signed into FF with.</li>*/}
        {/*                <li>How you supported the game (ko-fi, merch, zine)</li>*/}
        {/*            </ul>*/}

        {/*        </li>*/}
        {/*    </ol>*/}
        {/*    <br/>*/}
        {/*    <p>We’ll set your account to Supporter as fast as we can :)</p>*/}
        {/*</div>*/}
        <div className={"self-stretch flex flex-col self-center text-3xl"}>
          {user?.premium ? (
            <LinkButton variant={"black"} path="/zine">
              {t("supporter.body.zine")}
            </LinkButton>
          ) : (
            // <Link
            //   className={
            //     "w-full bg-black cursor-pointer text-center italic no-underline text-black hover:text-black visited:text-black"
            //   }
            //   to={"/zine"}
            // >
            //   <Button
            //     variant={"black"}
            //     // className={"w-full text-white bg-black text-xl py-2"}
            //   >
            //     {t("supporter.body.zine")}
            //   </Button>
            // </Link>
            <LinkButton disabled variant={"black"} path="#">
              {t("supporter.body.zine")}
            </LinkButton>

            // <Link
            //   className={
            //     "opacity-50 w-full bg-black pointer-events-none text-center italic no-underline text-black hover:text-black visited:text-black"
            //   }
            //   to={"#"}
            // >
            //   <Button
            //     variant={"black"}
            //     // className={"w-full text-white bg-black text-xl py-2"}
            //   >
            //     {t("supporter.body.zine")}
            //   </Button>
            // </Link>
          )}
        </div>
      </div>

      <div>
        <img src={footer} alt={"support us footer"} />
      </div>
    </MenuPage>
  );
};

export default Supporter;
